/*----- Core -----*/
import React     from 'react'
import styled    from 'styled-components'
import PropTypes from 'prop-types'

/*----- Components -----*/
import Paragraph from '../text/Paragraph'

/*----- Assets -----*/
import AvatarIcon from '../../assets/icons/avatar.svg'

/*----- Commons -----*/
import Color				 from '../../commons/Color'
import HandlerButton from '../button/HandlerButton'

/*----- Styles-----*/
const StyledProducerCard = styled.article`
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: center;
	border-radius: 8px;
	padding-bottom: 16px;
	transition: all 0.5s;
	margin: 8px;
	.producer-card__title {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		background: white;
		border-radius: 30px;
		height: 34px;
		height: fit-content;
		.custom-title {
				margin-bottom: 0;
		}
		.custom-paragraph {
			text-align: center;
			max-width: 260px;
			line-height: 20px;
		}
	}
	.producer-card__image-container {
		position: relative;
		img {
			width: 100px;
			border-radius: 50%;
		}
	}
	.producer-card__cover {
		border-radius: 50%;
		position: absolute;
		left: 0;
		right: 0;
		background-color: ${ Color.secondary };
		height: 100%;
		width: 100%;
		opacity: 0;
		transition: all 0.5s;
	}
	/*** Overwrite ***/
	.default-button {
		margin-top: 16px;
	}
	.custom-paragraph {
		font-size: 14px;
	}
`

/*----- Export -----*/
const ProducerCard = ({ imageUrl, name, lastname, onClick  }) => {

	return (
		<StyledProducerCard className="producer-card card">
			<div className="producer-card__image-container ">
				<div className="producer-card__cover"></div>
				<img src={ imageUrl? imageUrl : AvatarIcon } alt="person"/>
			</div>
			<div className="producer-card__title">
				<Paragraph bold content={ `${ name } ${ lastname }` } />
			</div>
			<HandlerButton content="ver" onClick={onClick} invert />
		</StyledProducerCard>
	)
}
export default ProducerCard

/*----- PropTypes -----*/
ProducerCard.propTypes = {
	imageUrl:    PropTypes.array,
	name:        PropTypes.string.isRequired,
}
